import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Créer une campagne de notification push',
  sent_title: "Notification en file d'attente",
  sent_subtitle:
    'Votre notification push a été envoyée à Apple et Google. Les confirmations de livraison arrivent dans environ 15 minutes.',
  sent_info_banner:
    'Vous pouvez fermer cette boîte de dialogue. Nous continuerons à vérifier et à mettre à jour les statistiques de livraison automatiquement.',
  circles: {
    sent_label: 'Envoyé',
    sent_sub: 'Envoyé aux abonnés',
    delivered_label: 'Livré',
    delivered_sub: "En attente d'Apple & Google",
    delivered_ready_short: 'Prêt',
    delivered_ready_sub: 'Actualisez pour voir les dernières statistiques',
  },
  scheduled_title: 'Campagne planifiée',
  scheduled_body_line_1: 'Votre notification push est planifiée pour {{when}}.',
  scheduled_body_line_2:
    "Nous l'enverrons automatiquement à ce moment. Les confirmations de livraison d'Apple et Google sont disponibles environ 15 minutes après l'envoi.",
  recipients_count_one: 'Envoyé à {{count}} abonné.',
  recipients_count_other: 'Envoyé à {{count}} abonnés.',
  close: 'Fermer',
  sections: {
    message: 'Message',
    audience: 'Audience',
    when: 'Quand envoyer',
    review: 'Vérification',
  },
  stepper: {
    message: 'Message',
    audience_when: 'Quand envoyer',
    review: 'Vérification',
  },
  blocked_reasons: {
    title_required: 'Ajoutez un titre pour continuer.',
    body_required: 'Ajoutez un corps de message pour continuer.',
    offer_required: 'Choisissez une offre pour continuer.',
    promo_code_required: 'Choisissez un code promo pour continuer.',
    send_option_required: 'Choisissez quand envoyer pour continuer.',
    scheduled_at_required: 'Choisissez une date et une heure pour continuer.',
  },
  fields: {
    title: {
      label: 'Titre',
      placeholder: 'Saisir le titre de la notification',
    },
    body: {
      label: 'Corps du message',
      placeholder: 'Saisir votre message',
    },
    audience: {
      label: 'Audience',
    },
    send_options: {
      label: "Options d'envoi",
    },
    date_and_time: {
      label: 'Date et heure',
      placeholder: 'Sélectionner date et heure',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Envoyer maintenant',
    [SendOptions.Schedule]: 'Planifier',
  },
  send_option_cards: {
    now: {
      title: 'Envoyer maintenant',
      description: 'Envoyer immédiatement à tous les abonnés.',
    },
    schedule: {
      title: 'Planifier',
      description: 'Choisissez une date et une heure dans le futur.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promotionnel 🚀',
      description: 'Promouvez une offre ou un code promo.',
    },
    informational: {
      title: 'Informationnel ℹ️',
      description: 'Partagez une actualité ou une mise à jour — sans remise associée.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Tous les utilisateurs ({{count}} appareil)',
  },
  preview: {
    title: 'Aperçu',
    notifications: {
      title: 'Le titre de votre notification apparaîtra ici',
      body: 'Le corps de votre message sera affiché ici avec tous les détails...',
      now: 'Maintenant',
    },
    estimated_reach: 'Portée',
  },
  summary: {
    title: 'Récapitulatif',
    reach: 'Portée',
    when: 'Quand',
    campaign_type: 'Type de campagne',
    promo_code: 'Code promo',
    offer: 'Offre',
    test_audience: "Envoyer d'abord un push test",
  },
  alerts: {
    daily_limit_reached: {
      title: "Limite d'envoi journalière atteinte",
      description:
        "Attention ! Envoyer plus d'une notification push par jour mécontente les utilisateurs et peut entraîner des désinstallations. C'est pourquoi nous limitons les envois manuels à 1/jour. Veuillez planifier ceci pour demain.",
    },
    offer_not_sendable: {
      title: "L'offre n'est pas valable aujourd'hui",
      description: 'Veuillez choisir une date dans le futur.',
    },
  },
  buttons: {
    send_now: 'Envoyer maintenant',
    save: 'Enregistrer',
    save_as_draft: 'Enregistrer comme brouillon',
    send_test: 'Envoyer un test',
    draft_with_ai: "Rédiger avec l'IA",
    back: 'Retour',
    next: 'Suivant',
  },
  feedback: {
    success: 'Campagne enregistrée avec succès',
    promo_code_expired: 'Code promo expiré',
    error: "Impossible d'enregistrer la campagne. Vérifiez votre connexion et réessayez.",
  },
};
